import { gql } from "@apollo/client";

export const MUTATIONS = {
  LOGIN: gql`
    mutation Login($username: String!, $password: String!) {
      login(username: $username, password: $password) {
        username
        token
        role
        buildings {
          id
          name
        }
      }
    }
  `,
  COMPUTE_COMMUNICATION_APARTMENTS_TARGETS: gql`
    mutation ComputeApartmentCommunicationTargets(
      $apartmentIds: [String!]!
      $userIds: [String!]
    ) {
      computeApartmentCommunicationTargets(
        apartmentIds: $apartmentIds
        userIds: $userIds
      ) {
        userId
        apartmentId
        apartmentCode
        apartmentName
        name
        email
      }
    }
  `,
  COMPUTE_COMMUNICATION_GROUP_TARGETS: gql`
    mutation ComputeCommunicationGroupTargets(
      $communicationGroupsIds: [String]!
    ) {
      computeCommunicationGroupTargets(
        communicationGroupsIds: $communicationGroupsIds
      ) {
        userId
        apartmentId
        apartmentCode
        apartmentName
        name
        email
      }
    }
  `,
  CREATE_AMENITY: gql`
    mutation CreateAmenity($amenityData: CreateAmenityData) {
      createAmenity(amenityData: $amenityData) {
        id
        name
        categoryName
        building {
          id
          name
        }
        color
        active
        airKeyLockId
        alertEmail
        isGuestParking
        isOnboardingAppointment
      }
    }
  `,
  CREATE_AMENITY_DEFINITION: gql`
    mutation CreateAmenityDefinition(
      $amenityDefinitionData: CreateAmenityDefinitionData
    ) {
      createAmenityDefinition(amenityDefinitionData: $amenityDefinitionData) {
        id
        name
      }
    }
  `,
  CREATE_AMENITY_RESERVATION: gql`
    mutation CreateAmenityReservation(
      $apartmentId: String!
      $targetUserId: String!
      $units: Int!
      $slots: [CreateAmenityReservationDataSlot]
      $esclusive: Boolean
      $guestParkingData: AmenityReservationGuestParkingDataInput
      $bookingData: BookingReservationDataInput
    ) {
      createAmenityReservation(
        apartmentId: $apartmentId
        targetUserId: $targetUserId
        units: $units
        slots: $slots
        esclusive: $esclusive
        guestParkingData: $guestParkingData
        bookingData: $bookingData
      ) {
        id
      }
    }
  `,
  CREATE_SERVICE_CATEGORY: gql`
    mutation CreateServiceCategory($dto: ServiceCategoryDto!) {
      createServiceCategory(dto: $dto) {
        id
        image {
          url
          name
        }
        icon {
          url
          name
        }
        i18n {
          name_it
          name_en
        }
        sortIndex
      }
    }
  `,
  UPDATE_SERVICE_CATEGORY: gql`
    mutation UpdateServiceCategory(
      $updateServiceCategoryId: String!
      $dto: ServiceCategoryDto!
    ) {
      updateServiceCategory(id: $updateServiceCategoryId, dto: $dto) {
        id
        image {
          url
          name
        }
        icon {
          url
          name
        }
        i18n {
          name_it
          name_en
        }
        sortIndex
      }
    }
  `,
  CREATE_AMENITY_RESERVATIONS_REPORT: gql`
    mutation CreateAmenityReservationsReport(
      $from: DateTime!
      $to: DateTime!
      $serviceId: String
      $serviceDefinitionId: String
      $apartmentIds: [String]
      $limit: Int
      $skip: Int
      $excludeDeleted: Boolean
    ) {
      createAmenityReservationsReport(
        from: $from
        to: $to
        serviceId: $serviceId
        serviceDefinitionId: $serviceDefinitionId
        apartmentIds: $apartmentIds
        limit: $limit
        skip: $skip
        excludeDeleted: $excludeDeleted
      ) {
        url
        name
      }
    }
  `,
  CREATE_APP_VERSION: gql`
    mutation CreateAppVersion($appVersionData: AppVersionInput!) {
      createAppVersion(appVersionData: $appVersionData) {
        id
      }
    }
  `,
  CREATE_CONTACT: gql`
    mutation CreateContact($contactData: ContactInput!) {
      createContact(contactData: $contactData) {
        id
      }
    }
  `,
  UPDATE_CONTACT: gql`
    mutation UpdateContact($id: String!, $contactData: ContactInput!) {
      updateContact(id: $id, contactData: $contactData) {
        id
      }
    }
  `,
  UPDATE_APP_VERSION: gql`
    mutation UpdateAppVersion($id: String!, $appVersionData: AppVersionInput!) {
      updateAppVersion(id: $id, appVersionData: $appVersionData) {
        id
      }
    }
  `,
  CREATE_COUPON: gql`
    mutation CreateCoupon($couponData: CouponInput!) {
      createCoupon(couponData: $couponData) {
        id
      }
    }
  `,
  CREATE_COUPON_USAGE_REPORT: gql`
    mutation CreateCouponUsageReport($couponId: String!) {
      createCouponUsageReport(id: $couponId) {
        name
        url
      }
    }
  `,
  UPDATE_COUPON: gql`
    mutation UpdateCoupon($id: String!, $couponData: CouponInput!) {
      updateCoupon(id: $id, couponData: $couponData) {
        id
      }
    }
  `,
  DELETE_APP_VERSION: gql`
    mutation DeleteAppVersion($id: String!) {
      deleteAppVersion(id: $id) {
        ok
      }
    }
  `,
  DELETE_COUPON: gql`
    mutation DeleteCoupon($id: String!) {
      deleteCoupon(id: $id) {
        ok
      }
    }
  `,
  DELETE_CONTACT: gql`
    mutation DeleteContact($id: String!) {
      deleteContact(id: $id) {
        ok
      }
    }
  `,
  SET_AMENITY_RESERVATION_DIDNT_SHOW_UP: gql`
    mutation setAmenityReservationDidntShowUp(
      $id: String!
      $didntShowUp: Boolean!
    ) {
      setAmenityReservationDidntShowUp(id: $id, didntShowUp: $didntShowUp) {
        ok
      }
    }
  `,
  CAPTURE_RESERVATION_PAYMENT_INTENT: gql`
    mutation CaptureReservationPaymentIntent(
      $id: String!
      $amountToCapture: Float!
    ) {
      captureReservationPaymentIntent(
        id: $id
        amountToCapture: $amountToCapture
      ) {
        ok
      }
    }
  `,
  UPDATE_MANAGED_RESERVATION: gql`
    mutation UpdateManagedReservation(
      $id: String!
      $newAmount: Float!
      $lastTimeForPayment: DateTime!
      $sendPushNotification: Boolean
      $pushMessage: String
    ) {
      updateManagedReservation(
        id: $id
        newAmount: $newAmount
        lastTimeForPayment: $lastTimeForPayment
        sendPushNotification: $sendPushNotification
        pushMessage: $pushMessage
      ) {
        ok
      }
    }
  `,
  CONFIRM_POSTBACK_PAYMENT: gql`
    mutation ConfirmPostbackPayment($reservationId: String!) {
      confirmPostbackPayment(reservationId: $reservationId) {
        ok
      }
    }
  `,
  CONFIRM_SERVICE_RESERVATION: gql`
    mutation ConfirmServiceReservation($serviceReservationId: String!) {
      confirmServiceReservation(serviceReservationId: $serviceReservationId) {
        ok
      }
    }
  `,
  CREATE_UNAVAILABLE_SLOT: gql`
    mutation CreateServiceUnavailableSlot($data: ServiceUnavailableSlotInput!) {
      createServiceUnavailableSlot(data: $data) {
        id
      }
    }
  `,
  DELETE_UNAVAILABLE_SLOT: gql`
    mutation DeleteServiceUnavailableSlot($id: String!) {
      deleteServiceUnavailableSlot(id: $id) {
        ok
      }
    }
  `,
  CREATE_APARTMENT: gql`
    mutation CreateApartment(
      $name: String
      $code: String!
      $building: CreateApartmentBuilding!
      $owner: CreateApartmentOwner
      $reservationOptions: [UpdateApartmentReservationOptions]
      $domoticsProvider: String
      $wiserOpts: InputApartmentWiserOpts
      $underConstruction: Boolean
      $floorInfo: String
    ) {
      createApartment(
        name: $name
        code: $code
        building: $building
        owner: $owner
        reservationOptions: $reservationOptions
        domoticsProvider: $domoticsProvider
        wiserOpts: $wiserOpts
        underConstruction: $underConstruction
        floorInfo: $floorInfo
      ) {
        id
        code
        building {
          id
          name
        }
        owner {
          id
          name
          email
          phone
        }
        underConstruction
      }
    }
  `,
  CREATE_APARTMENT_SURVEYS_REPORT: gql`
    mutation CreateApartmentSurveysReport($buildingId: String) {
      createApartmentSurveysReport(buildingId: $buildingId) {
        name
        url
      }
    }
  `,
  CREATE_SERVICE_RESERVATIONS_REPORT: gql`
    mutation CreateServiceReport(
      $from: DateTime
      $to: DateTime
      $serviceId: String
    ) {
      createServiceReservationsReport(
        from: $from
        to: $to
        serviceId: $serviceId
      ) {
        name
        url
      }
    }
  `,
  SET_APARTMENT_SHOULD_COMPLETE_SURVEY: gql`
    mutation SetApartmentShouldCompleteSurvey(
      $apartmentId: String!
      $shouldCompleteSurvey: Boolean!
    ) {
      setApartmentShouldCompleteSurvey(
        apartmentId: $apartmentId
        shouldCompleteSurvey: $shouldCompleteSurvey
      ) {
        ok
      }
    }
  `,
  CREATE_USERS_LATEST_PRIVACY_REPORT: gql`
    mutation CreateUsersLatestPrivacyPreferencesReport {
      createUsersLatestPrivacyPreferencesReport {
        url
        name
      }
    }
  `,
  /**
   * Adds an user to an apartament.
   *
   * In case `userData.username` is specified, `invite` is performed, otherwise
   * create is performed.
   */
  ADD_APARTMENT_USER: gql`
    mutation AddApartmentUser(
      $userData: NewApartmentUserData!
      $apartmentId: String!
    ) {
      addApartmentUser(userData: $userData, apartmentId: $apartmentId) {
        id
      }
    }
  `,
  REMOVE_USER_FROM_APARTMENT: gql`
    mutation RemoveUserFromApartment($userId: String!, $apartmentId: String!) {
      removeUserFromApartment(userId: $userId, apartmentId: $apartmentId) {
        id
      }
    }
  `,
  CREATE_BUILDING: gql`
    mutation CreateBuilding(
      $name: String!
      $code: String
      $primaryColor: String
      $logo: String
      $mainPhone: String
      $latitude: Float
      $longitude: Float
      $zipCode: String
      $hasElevator: Boolean
      $rulesDoc: BucketAttachmentInput
      $faqs: [BuildingFaqInput]
      $laundryOpts: BuildingLaundryOptsInput
      $otherAttachments: [BucketAttachmentInput!]
      $disableDomotics: Boolean
      $airKeyApiKey: String
      $onboarding: BuildingOnboardingInput
      $guestParking: BuildingGuestParkingInput
      $showInstalments: Boolean
      $enableInstalments: Boolean
      $instalmentsPaymentConfigs: PaymentConfigsInput
    ) {
      createBuilding(
        name: $name
        code: $code
        primaryColor: $primaryColor
        logo: $logo
        mainPhone: $mainPhone
        latitude: $latitude
        longitude: $longitude
        zipCode: $zipCode
        hasElevator: $hasElevator
        rulesDoc: $rulesDoc
        faqs: $faqs
        laundryOpts: $laundryOpts
        otherAttachments: $otherAttachments
        disableDomotics: $disableDomotics
        airKeyApiKey: $airKeyApiKey
        onboarding: $onboarding
        guestParking: $guestParking
        showInstalments: $showInstalments
        enableInstalments: $enableInstalments
        instalmentsPaymentConfigs: $instalmentsPaymentConfigs
      ) {
        id
        name
        code
        primaryColor
        logo
        mainPhone
        rulesDoc {
          url
          name
        }
      }
    }
  `,
  CREATE_BUILDING_MEDIA: gql`
    mutation CreateBuildingMedia($buildingMedia: BuildingMediaInput!) {
      createBuildingMedia(buildingMedia: $buildingMedia) {
        id
      }
    }
  `,
  UPDATE_BUILDING_MEDIA: gql`
    mutation UpdateBuildingMedia(
      $buildingMediaId: String!
      $buildingMedia: BuildingMediaInput!
    ) {
      updateBuildingMedia(
        buildingMediaId: $buildingMediaId
        buildingMedia: $buildingMedia
      ) {
        id
      }
    }
  `,
  CREATE_SERVICE_TYPE_LIST_ITEM: gql`
    mutation CreateServiceTypeListItem(
      $serviceTypeListItemData: ServiceTypeListItemInput!
    ) {
      createServiceTypeListItem(
        serviceTypeListItemData: $serviceTypeListItemData
      ) {
        id
      }
    }
  `,
  UPDATE_SERVICE_TYPE_LIST_ITEM: gql`
    mutation UpdateServiceTypeListItem(
      $id: String!
      $serviceTypeListItemData: ServiceTypeListItemInput!
    ) {
      updateServiceTypeListItem(
        id: $id
        serviceTypeListItemData: $serviceTypeListItemData
      ) {
        id
      }
    }
  `,
  REORDER_SERVICE_TYPE_LIST_ITEMS: gql`
    mutation RecorderListItems($id: String!, $moveIndex: Int!) {
      reorderListItems(id: $id, moveIndex: $moveIndex) {
        ok
      }
    }
  `,
  DELETE_SERVICE_TYPE_LIST_ITEM: gql`
    mutation DeleteServiceTypeListItem($id: String!) {
      deleteServiceTypeListItem(id: $id) {
        ok
      }
    }
  `,
  UPDATE_BUILDING: gql`
    mutation UpdateBuilding(
      $buildingId: String!
      $name: String!
      $code: String
      $primaryColor: String
      $logo: String
      $mainPhone: String
      $latitude: Float
      $longitude: Float
      $zipCode: String
      $hasElevator: Boolean
      $rulesDoc: BucketAttachmentInput
      $otherAttachments: [BucketAttachmentInput!]
      $faqs: [BuildingFaqInput]
      $laundryOpts: BuildingLaundryOptsInput
      $disableDomotics: Boolean
      $airKeyApiKey: String
      $onboarding: BuildingOnboardingInput
      $guestParking: BuildingGuestParkingInput
      $showInstalments: Boolean
      $enableInstalments: Boolean
      $instalmentsPaymentConfigs: PaymentConfigsInput
    ) {
      updateBuilding(
        buildingId: $buildingId
        name: $name
        code: $code
        primaryColor: $primaryColor
        logo: $logo
        mainPhone: $mainPhone
        latitude: $latitude
        longitude: $longitude
        zipCode: $zipCode
        hasElevator: $hasElevator
        rulesDoc: $rulesDoc
        otherAttachments: $otherAttachments
        faqs: $faqs
        laundryOpts: $laundryOpts
        disableDomotics: $disableDomotics
        airKeyApiKey: $airKeyApiKey
        onboarding: $onboarding
        guestParking: $guestParking
        showInstalments: $showInstalments
        enableInstalments: $enableInstalments
        instalmentsPaymentConfigs: $instalmentsPaymentConfigs
      ) {
        id
        name
        code
        primaryColor
        logo
        mainPhone
        rulesDoc {
          url
          name
        }
      }
    }
  `,
  CREATE_COMMUNICATION: gql`
    mutation CreateCommunication($communicationData: CommunicationData!) {
      createCommunication(communicationData: $communicationData) {
        id
        name
      }
    }
  `,
  CREATE_COMMUNICATION_GROUP: gql`
    mutation CreateCommunicationGroup(
      $communicationGroupData: CommunicationGroupData!
    ) {
      createCommunicationGroup(
        communicationGroupData: $communicationGroupData
      ) {
        id
        name
      }
    }
  `,
  CREATE_SERVICE: gql`
    mutation CreateService($serviceData: ServiceInput!) {
      createService(serviceData: $serviceData) {
        id
      }
    }
  `,
  CREATE_SYSTEM_USER: gql`
    mutation CreateSystemUser($systemUserData: CreateSystemUserData!) {
      createSystemUser(systemUserData: $systemUserData) {
        id
        username
      }
    }
  `,
  HIDE_USER: gql`
    mutation DeleteUser($userId: String!) {
      deleteUser(userId: $userId) {
        ok
      }
    }
  `,
  DELETE_AMENITY_RESERVATION: gql`
    mutation DeleteAmenityReservation($id: String!) {
      deleteAmenityReservation(id: $id) {
        ok
      }
    }
  `,
  DELETE_SERVICE_RESERVATION: gql`
    mutation DeleteServiceReservation($id: String!) {
      deleteServiceReservation(serviceReservationId: $id) {
        ok
      }
    }
  `,
  FORCE_PASSWORD: gql`
    mutation ForcePassword($targetUserId: String!, $newPassword: String!) {
      forcePassword(targetUserId: $targetUserId, newPassword: $newPassword) {
        ok
      }
    }
  `,
  UPDATE_DEVICE: gql`
    mutation UpdateDevice($id: String!, $deviceData: DeviceInput!) {
      updateDevice(id: $id, deviceData: $deviceData) {
        id
      }
    }
  `,
  UPDATE_AMENITY: gql`
    mutation UpdateAmenity($amenityData: UpdateAmenityData) {
      updateAmenity(amenityData: $amenityData) {
        id
        name
        categoryName
        building {
          id
          name
        }
        color
        active
        airKeyLockId
        alertEmail
        isGuestParking
        isOnboardingAppointment
      }
    }
  `,
  UPDATE_SERVICE: gql`
    mutation UpdateService($id: String!, $serviceData: ServiceInput!) {
      updateService(id: $id, serviceData: $serviceData) {
        id
      }
    }
  `,
  DELETE_SERVICE: gql`
    mutation DeleteService($id: String!) {
      deleteService(id: $id) {
        ok
      }
    }
  `,
  RESTORE_SERVICE: gql`
    mutation RestoreService($id: String!) {
      restoreService(id: $id) {
        ok
      }
    }
  `,
  UPDATE_AMENITY_DEFINITION: gql`
    mutation UpdateAmenityDefinition(
      $id: String!
      $amenityDefinitionData: CreateAmenityDefinitionData
    ) {
      updateAmenityDefinition(
        id: $id
        amenityDefinitionData: $amenityDefinitionData
      ) {
        id
        name
      }
    }
  `,
  UPDATE_APARTMENT: gql`
    mutation UpdateApartment(
      $id: String!
      $name: String!
      $code: String!
      $owner: CreateApartmentOwner
      $reservationConductStatus: UpdateApartmentReservationConductStatus
      $reservationOptions: [UpdateApartmentReservationOptions]
      $domoticsProvider: String
      $wiserOpts: InputApartmentWiserOpts
      $underConstruction: Boolean
      $onboarding: ApartmentOnboardingInput
      $floorInfo: String
      $tag: String
    ) {
      updateApartment(
        id: $id
        name: $name
        code: $code
        owner: $owner
        reservationConductStatus: $reservationConductStatus
        reservationOptions: $reservationOptions
        domoticsProvider: $domoticsProvider
        wiserOpts: $wiserOpts
        underConstruction: $underConstruction
        onboarding: $onboarding
        floorInfo: $floorInfo
        tag: $tag
      ) {
        id
        code
        building {
          id
          name
          code
        }
        owner {
          id
          name
          email
          phone
        }
        underConstruction
      }
    }
  `,
  RESET_APARTMENT_CONDUCT_STATUS: gql`
    mutation ResetApartmentConductStatus($apartmentId: String!) {
      resetApartmentConductStatus(apartmentId: $apartmentId) {
        ok
      }
    }
  `,
  SET_SLOT_KEY_OVERRIDE: gql`
    mutation SetSlotKeyOverride(
      $slotOverrideData: ServiceTimeSlotVariationInput!
    ) {
      setSlotKeyOverride(slotOverrideData: $slotOverrideData) {
        ok
      }
    }
  `,
  UPDATE_COMMUNICATION: gql`
    mutation UpdateCommunication(
      $id: String!
      $communicationData: CommunicationData!
    ) {
      updateCommunication(id: $id, communicationData: $communicationData) {
        id
        name
      }
    }
  `,
  UPDATE_COMMUNICATION_GROUP: gql`
    mutation UpdateCommunicationGroup(
      $id: String!
      $communicationGroupData: CommunicationGroupData!
    ) {
      updateCommunicationGroup(
        id: $id
        communicationGroupData: $communicationGroupData
      ) {
        id
        name
      }
    }
  `,
  UPDATE_ROOM: gql`
    mutation UpdateRoom($id: String!, $roomData: RoomInput!) {
      updateRoom(id: $id, roomData: $roomData) {
        id
      }
    }
  `,
  UPDATE_SYSTEM_USER: gql`
    mutation UpdateSystemUser($systemUserData: UpdateSystemUserData!) {
      updateSystemUser(systemUserData: $systemUserData) {
        id
        username
      }
    }
  `,
  FORCE_RESET_USER_PASSWORD: gql`
    mutation ForceResetPassword($id: String!) {
      forceResetPassword(id: $id) {
        ok
      }
    }
  `,
  RESERVE_SERVICE: gql`
    mutation ReserveService(
      $targetUserId: String
      $serviceId: String!
      $slots: [ServiceReservationReservableSlotInput!]!
      $amenitySlots: [CreateAmenityReservationDataSlot]
      $serviceTypeListItemsIds: [String!]!
      $additionalDetails: String
      $vehicleId: String
      $invoiceRequested: Boolean
      $reservationToMoveId: String
    ) {
      reserveService(
        targetUserId: $targetUserId
        serviceId: $serviceId
        slots: $slots
        amenitySlots: $amenitySlots
        serviceTypeListItemsIds: $serviceTypeListItemsIds
        additionalDetails: $additionalDetails
        vehicleId: $vehicleId
        invoiceRequested: $invoiceRequested
        reservationToMoveId: $reservationToMoveId
      ) {
        id
      }
    }
  `,
  RESET_ACTIVATION_PROCESS: gql`
    mutation ResetActivationProcess($userId: String!) {
      resetActivationProcess(userId: $userId) {
        ok
      }
    }
  `,
  UPLOAD_IMAGE: gql`
    mutation UploadImage($file: Upload!) {
      uploadImage(file: $file)
    }
  `,
};
